import FJNetworkStore from "./FJNetworkStore";
import lzutf8 from 'lzutf8';
import FJEventConstant from "../constant/FJEventConstant";
import FJCanvasStore from "./FJCanvasStore";
import JSZip from "jszip";
import FJUtil from "../util/FJUtil";
import FJCoreConstant from "../core/constant/FJCoreConstant";
import FJConfig from "../config/FJConfig";
import FJMediaCacheStore from "./FJMediaCacheStore";

/**
 * @class FJSaveStore
 * @classdesc 工程保存单例
 */
let FJSaveStore = (function () {

  const _delay = 5000;
  const _SAVE_STATUS = {
    SAVE: 'SAVE',
    SAVING: 'SAVING',
    SAVED: 'SAVED',
  }
  let _status = FJUtil && FJUtil.isAnonymousProject() ? _SAVE_STATUS.SAVE : _SAVE_STATUS.SAVED;
  let _recordData = null; // 记录工程数据
  let _recordId = null; // 记录工程id
  let _isFlushSaving = false; // 当前保存是否是立即保存
  let _timer = null;
  let _useAutoSave = process.env.NODE_ENV === 'production';

  /**
   * @description 清除记录数据
   */
  function clearRecordData() {
    _recordId = null;
    _recordData = null;
  }

  /**
   * @description 改变保存状态
   * @param status
   */
  function changeSaveStatus(status) {
    _status = status;
    window.FJEvent.dispatch(FJEventConstant.CHANGE_SAVE_STATUS, _status);
  }

  /**
   * @description 保存成功回调
   */
  function saveSuccessFunc(response) {

    if (response && response.data && response.data.key) {
      let key = response.data.key;
      let {savePath} = FJConfig;
      FJCanvasStore.executeSync(FJCanvasStore.command.SET_PROJECT_ID, key);
      window.history.replaceState({id: 0}, document.title, `${savePath}?id=${key}`);
    }

    if (_recordData) {
      delaySave();
    } else {
      changeSaveStatus(_SAVE_STATUS.SAVED);
    }

    window.FJEvent.dispatch(FJEventConstant.SAVE_ONLINE_SUCCESS);
  }

  /**
   * @description 保存失败回调
   */
  function saveFailFunc(error) {
    delaySave();

    let code = Number(error.message);
    if (code === 404) {
      window.onbeforeunload = () => {};
      if (process.env.SERVE_ENV === 'release') {
        window.location.href = 'https://www.flexclip.com';
      } else if (process.env.SERVE_ENV === "dev") {
        window.location.href = 'https://www.smartvideomaker.com';
      }
      return;
    }
    if (_isFlushSaving) {
      window.FJEvent.dispatch(FJEventConstant.SAVE_ONLINE_ERROR, {error, isFlushSaving: _isFlushSaving});
    }
  }

  /**
   * @description 延迟保存
   */
  function delaySave() {
    changeSaveStatus(_SAVE_STATUS.SAVE);

    if (_useAutoSave && FJUtil.isLogin() && !FJUtil.isAnonymousProject()) {
      clearTimer();
      _timer = setTimeout(() => {
        fetchSave(false);
      }, _delay);
    }
  }

  /**
   * @description 触发保存请求
   * @param isFlushSaving
   */
  function fetchSave(isFlushSaving) {
    changeSaveStatus(_SAVE_STATUS.SAVING);
    _isFlushSaving = isFlushSaving;
    let _savingData = _recordData;
    let _savingId = _recordId;
    clearRecordData();
    let failFunc = (error) => {
      _recordData = Object.assign(_savingData, _recordData);
      _recordId = _savingId;
      saveFailFunc(error);
    };
    let resources = {};
    let pushResource = (sourceId) => {
      let mediaCache = FJMediaCacheStore.getMediaCache(sourceId);
      let blob = mediaCache && mediaCache.getBlob();
      if (blob) {
        resources[sourceId] = blob;
      }
    };
    try {
      _savingData.graphs.forEach(graph => {
        if (graph.type === FJCoreConstant.DYNAMIC_LOGO) {
          graph.images.forEach(image => {
            pushResource(image.sourceId);
          });
        }
      });
      if (_savingData.watermark.activeType  === FJCoreConstant.WATERMARK_IMAGE && _savingData.watermark.watermarkImage) {
        pushResource(_savingData.watermark.watermarkImage.sourceId);
      }
      FJCanvasStore.executeSync(FJCanvasStore.command.CLEAR_LOGIN_TO_SAVE_TIMER);
    } catch (e) {
      failFunc(e);
      return ;
    }
    FJCanvasStore.execute(FJCanvasStore.command.RENDER_COVER).then((canvas) => {
      return new Promise((resolve) => {
        canvas.toBlob(resolve);
      });
    }).then((coverBlob) => {
      let zip = new JSZip();
      // console.log(JSON.stringify(_savingData));
      let {graphs, mediaLibrary, transitions, layer, watermark} = _savingData;
      console.log(_savingData);
      _savingData.version = FJConfig.projectVersion;
      if (_savingData.version === '3') {

        // version 2
        _savingData.graphs = lzutf8.compress(JSON.stringify(graphs), {outputEncoding: 'Base64'});
        _savingData.mediaLibrary = lzutf8.compress(JSON.stringify(mediaLibrary), {outputEncoding: 'Base64'});
        _savingData.transitions = lzutf8.compress(JSON.stringify(transitions), {outputEncoding: 'Base64'});

        // version 3
        _savingData.layer = lzutf8.compress(JSON.stringify(layer), {outputEncoding: 'Base64'});
        _savingData.watermark = lzutf8.compress(JSON.stringify(watermark), {outputEncoding: 'Base64'});
      }
      zip.file('info.json', JSON.stringify(_savingData));
      zip.file('cover.jpg', coverBlob);
      let resourceFolder = zip.folder("resource");
      for (let id in resources) {
        if (resources.hasOwnProperty(id)) {
          let resource = resources[id];
          resourceFolder.file(`${id}.png`, resource);
        }
      }
      zip.generateAsync({type: "blob"})
        .then(function (content) {
          FJNetworkStore.saveProject(_savingId, content)
            .then(saveSuccessFunc)
            .catch(failFunc)
        }).catch(failFunc);
    }).catch(failFunc);
  }

  /**
   * @description 清除延迟保存的计时器
   */
  function clearTimer() {
    if (_timer) {
      clearTimeout(_timer);
    }
  }

  return {

    get SAVE_STATUS() {
      return _SAVE_STATUS;
    },

    get status() {
      return _status;
    },

    /**
     * @description 保存
     * @param id
     * @param data
     * @param {boolean} flush 是否立即保存
     */
    save: function (id, data, flush) {
      _recordId = id;
      _recordData = data;

      if (_status === _SAVE_STATUS.SAVING) {
        return;
      }

      if (flush) {
        clearTimer();
        fetchSave(true);
      } else {
        delaySave();
      }
    },

    /**
     * @description 启用自动保存
     */
    enableAutoSave: function () {
      _useAutoSave = true;
    },

    /**
     * @description 禁用自动保存
     */
    disableAutoSave() {
      _useAutoSave = false;
    },
  };

})();

export default FJSaveStore;
